import type { ActionResponse } from 'api/__GENERATED';
import { timeUtility } from 'utility';

// Maps a single ActionResponse DTO to Data.Action.
// startAt/endAt are ISO strings from the API — toTimeDate converts them to
// a Time.Hour, then convertHour narrows down to Time.Day. The narrowing step
// is load-bearing: Data.Action.startAt is typed as `Omit<DateItem, 'hour'>`
// (no `hour` field, no `type` discriminant), but TS only checks structural
// shape, so without convertHour the leftover `type: 'hour'` and `hour`
// properties would ride along at runtime. Downstream form code spreads the
// value with `{ type: 'day', ...startAt }` and the leaked `type: 'hour'`
// would override the explicit `type: 'day'`, routing the formatter to
// formatHour and rendering the date as MISSING after a round-trip through
// the API.
function toAction(dto: ActionResponse): Data.Action {
  const {
    id,
    improvementAreaId,
    title,
    problemStatement,
    solutionProposal,
    definitionOfDone,
    status,
    priority,
    startAt: _startAt,
    endAt: _endAt,
    responsibleEmployee,
    suggestionIds,
  } = dto;

  const action: Data.Action = {
    id,
    improvementAreaId,
    name: title ?? '',
    problemStatement,
    solutionProposal,
    definitionOfDone,
    status,
    priority,
    startAt: timeUtility.convertHour(
      'day',
      timeUtility.toTimeDate(new Date(_startAt)),
    ),
    endAt: timeUtility.convertHour(
      'day',
      timeUtility.toTimeDate(new Date(_endAt)),
    ),
    responsibleEmployee,
    suggestionIds,
  };

  return action;
}

export { toAction };
